/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "LgvgQgtng0U",
    title: "Benefits of Fasting | Sadhguru",
    description:
      "Sadhguru talks about how most people suffer many ill effects because they do not give their body a break from the process of ingesting food. He explains the importance of fasting and how it can prevent many chronic ailments from building up in the body.",
    creator: "Sadhguru",
    category:"Diet"
  },
  {
    _id: "pHLVKZWqZYE",
    title: "Miraculous Benefits of Eating Fruits",
    creator: "Sadhguru",
    category: "Diet",
    description:
      "Eating fruits can bring you miraculous benefits and also help the environment. In this video, Sadhguru tells us how eating fruits can benefit our digestive system and bring us energy that can help you work at our best throughout the day. He also explains how eating fruits and making it a ",
  },
  {
    _id: "DnRQJzK6yvI",
    title: "Intermittent Fasting: Handle Your Health Problems The Natural Way",
    creator: "Sadhguru",
    category: "Diet",
    description:
      "Intermittent fasting is an age old practice that has recently gained mainstream attention for its widespread success in helping relieve various health problems. Sadhguru discusses how to go about it and the benefits that you can expect.",
  },
  {
  _id: "_wq-OiPk-pU",
    title: "Surya Kriya - Fire Up The Sun Within | Isha Hata Yoga",
    creator: "Sadhguru",
    category: "Yoga",
    description:
  "Surya Kriya - Fire Up The Sun Within | Isha Hata Yoga Surya Kriya is a potent yogic practice of tremendous antiquity, designed as a holistic process for health, wellness and complete inner wellbeing. Surya means Sun, and kriya means inner energy process. Surya Kriya activates the solar plexus within the system and balances a person's energies, leading to stability of the body and stillness of the mind. This strong foundation becomes the basis to explore higher dimensions of life. Traditionally available only to select groups of yogis, Surya Kriya is being offered by Sadhguru as a comprehensive spiritual practice that is ideal for the hectic pace of today's world.",
  },
  {
    _id: "edIK5SZYMZo",
    title: "Replace Treadmill With This 10 Min HIIT/CARDIO Workout",
    creator: "THENX",
    category: "Cardio",
    description:
      "Join Chris Heria as he shows you how to Replace Treadmill With this 10 Min HIIT/CARDIO Workout that is going to build muscle and burn fat. ",
  },
  {
    _id: "gnTzk1yUHB4",
    title: "Complete 15 Min Full Body Workout | No Equipment",
    creator: "THENX",
    category: "Cardio",
    description:
      "Follow along with Chris Heria as he shows you a Complete 15 Min Full Body Workout without the need of any equipment.",
  },
  {
    _id: "uGNc_36AOPs",
    title: "Vidyut's Kalari Dand (Push-Ups) - Part Two | Kalaripayattu | Martial Arts",
    creator: "Vidyut Jamwal",
    category: "Kalari",
    description:
      "There is never just one way to do an exercise. We all know the usual way to do Push-Ups. Now learn more than a dozen new ways to do push-ups.",
  },
  {
    _id: "lYFhP4lemTU",
    title: "Vidyut's Kalari Chikitsa (Part-3) | Kalaripayattu | Martial Arts |",
    creator: "Vidyut Jamwal",
    category: "Healing",
    description:
      "Marma warm-up- as a practitioner of the oldest form of martial art, Kalaripayattu, it's believed that when our 7 systems are aligned and harmonious, one can be the perfect human being. ",
  },
  {
    _id: "wOGqlVqyvCM",
    title: "5 Tips to Improve your Mental Health",
    creator: "Sadhguru",
    category: "Mental Health",
    description:
      "Here are 5 simple and effective tips from Sadhguru to enhance our mental health.",

  },
  {
    _id: "h91btaHcLWU",
    title: "Traditional Iron Hand Training",
    creator: "Karate TV",
    category: "Martial Arts",
    description:
      "",

  },
  {
    _id: "0iQzVKwHV8E",
    title: "10 BEST FOREARM EXCERCISES",
    creator: "Karate TV",
    category: "Martial Arts",
    description:
      "",

  },
  {
    _id: "FwoPpCZhCjg",
    title: "STRONG NECK WORKOUT .",
    creator: "Karate TV",
    category: "Martial Arts",
    description:
      "",

  }
  ,
  {
    _id: "cslIbZERhSc",
    title: "25 Tricking KICKS | A Progressive Session",
    creator: "Mastering Tricking",
    category: "Martial Arts",
    description:
      "",

  },
  {
    _id: "oWjSdwzOA6k",
    title: "8 principles to achieve optimum mental health | Dan Banos | TEDxRockhampton",
    creator: "TEDx Talks",
    category: "Mental Health",
    description:
      "",

  },
  {
    _id: "rkZl2gsLUp4",
    title: "How to manage your mental health | Leon Taylor | TEDxClapham",
    creator: "TEDx Talks",
    category: "Mental Health",
    description:
      "",

  },
  {
    _id: "lo0X2ZdElQ4",
    title: "Consciousness -- the final frontier | Dada Gunamuktananda | TEDxNoosa 2014",
    creator: "TEDx Talks",
    category: "Mental Health",
    description:
      "",

  },
  {
    _id: "4O2JK_94g3Y",
    title: "Unwavering Focus | Dandapani | TEDxReno",
    creator: "TEDx Talks",
    category: "Mental Health",
    description:
      "",

  },
  {
    _id: "1XCObQjSHIs",
    title: "One Thing You Must Do to Overcome Anxiety | Sadhguru",
    creator: "Sadhguru",
    category: "Mental Health",
    description:
      "",

  },
  {
    _id: "xQeX2YZTjLY",
    title: "SADHGURU - SWITCH To This DIET! It Can Do HEALTH WONDERS in Your Body - The Indian Mystics",
    creator: "Sadhguru",
    category: "Diet",
    description:
      "",

  },
  {
    _id: "0mYwsA8Ajks",
    title: "Top yogic super foods explained by Sadhguru -(For high energy,stability, health and detoxification )",
    creator: "Sadhguru",
    category: "Diet",
    description:
      "",

  }
];
